/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

let personalizeBtn = undefined;
document.addEventListener("DOMContentLoaded", (event) => {
  var timer = setInterval(() => {
    const personalizeContainer = document.querySelector('.product__submit__item.personalize');
    personalizeBtn = document.querySelector('#customily-personalize-button');
   // console.log(personalizeContainer);
    if (personalizeBtn) {
      personalizeContainer.appendChild(personalizeBtn);
      clearInterval(timer);
    } 
  }, 1000);


  setTimeout(() => {
    clearInterval(timer);
  }, 7000);
});
